export const AD_UNIT_PREFIX = 'kaskus-pwa-tv';
export const CATEGORY_PREFIX = 'tv-';
export const DIV_PREFIX = 'div-gpt-ad-';
export const DFP_NETWORK_ID = '21995995410';
export const EMPTY_PROGRAM = '-';
export const EMPTY_CATEGORY = 'tv-other';

export enum AD_TYPE {
  BOTTOM_FRAME = 'bottom-frame',
  MASTERHEAD = 'masterhead',
  RECTANGLE = 'rectangle'
}
